import React, { useEffect, useState } from "react";
import { AvailabilityType } from "../../types/loadedData";
import { useAvailability } from "../../hooks/useAvailability";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../router/Paths";
export const ReviewProductAvailibility = () => {
  const { getAvailability } = useAvailability();
  const [availability, setAvailability] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(5);
  const [available, setAvailable] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAvailability = async () => {
      setLoading(true);
      const response = await getAvailability(page, limit, available);
      console.log("availability review", response.availability);
      setAvailability(response.availability);
      setLoading(false);
    };
    fetchAvailability();
  }, [page, limit, available]);

  const gotoAvailability = () => {
    navigate(Paths.availablity);
  };

  return (
    <div className="bg-white p-4 lg:p-6 rounded-lg shadow-md mb-8">
      {loading ? (
        <div className="text-center">Loading...</div>
      ) : (
        <>
          <h2 className="text-lg font-semibold mb-4">
            Review product availability
          </h2>
          <p className="mb-4 text-sm lg:text-base">
            Review availability to ensure timely action on the following
            products
          </p>
          {/* Availability Card */}
          {availability.length > 0 ? (
            availability.map((tour) => (
              <div className="p-4 border border-gray-300 rounded-lg flex flex-col lg:flex-row items-center gap-4 lg:gap-8">
                {/* Image */}
                {tour?.gallery?.length > 0 ? (
                  <div className="w-24 h-24 rounded-md flex-shrink-0">
                    <img
                      src={tour.gallery[0]}
                      alt="availability cover"
                      className="object-cover w-full h-full rounded-md"
                    />
                  </div>
                ) : (
                  <div className="w-24 h-24 bg-gray-200 rounded-md flex-shrink-0"></div>
                )}
                <div className="flex-grow text-center lg:text-left">
                  <h3 className="font-semibold">{tour?.title}</h3>
                  <p className="text-md">Option: {tour?.options?.title}</p>
                  <p className="text-md mt-5">Expired on: </p>
                </div>
                <div className="text-center lg:text-right space-y-2 lg:space-y-8">
                  <p className="text-red-500 bg-red-100 px-2 py-1 rounded-md text-sm">
                    No active options
                  </p>
                  <button
                    onClick={gotoAvailability}
                    className="text-blue-500 font-semibold"
                  >
                    Update Availability
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center">No product availability found</p>
          )}
        </>
      )}
    </div>
  );
};
